import { inject, Injectable } from '@angular/core';
import { UsertStore } from '../context/userStore';
import { StorageService } from '../context/storageService';
import { MhsConfigurationApiClient } from '../api/mhsConfigurationApiClient';
import { AuthStore } from '../authentication/authStore';
import { EMPTY } from 'rxjs/internal/observable/empty';
import { CompanyConfiguration } from './dto/company-configuration';
import { Observable } from 'rxjs/internal/Observable';
import { switchMap } from 'rxjs/internal/operators/switchMap';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { distinctUntilChanged } from 'rxjs/internal/operators/distinctUntilChanged';
import { filter } from 'rxjs/internal/operators/filter';
import { map } from 'rxjs/internal/operators/map';
import { TenantService } from './tenant-service';
import { MhsInternalApiClient, ModuleDto } from '../api/mhsInternalApiClient';
import { tap } from 'rxjs/internal/operators/tap';
import { of } from 'rxjs/internal/observable/of';
import { STORAGE_KEY_COMPANY } from '../context/storage-keys';
import { log } from 'ng-zorro-antd/core/logger';
import { ModulesLookup } from '../context/modules-lookup';
import { ModuleEnhanced } from './dto/module-enhanced';
@Injectable({
  providedIn: 'root',
})
export class CompanyConfigurationService {
  configurationApiClient = inject(MhsConfigurationApiClient);
  interalApiClient = inject(MhsInternalApiClient);
  localStorageService = inject(StorageService);
  authStore = inject(AuthStore);
  userStore = inject(UsertStore);
  tenantService = inject(TenantService);
  getCompanyConfiguration(): Observable<CompanyConfiguration> {
    if (this.authStore.accessToken() === '') {
      return EMPTY;
    }

    if (this.localStorageService.get(STORAGE_KEY_COMPANY)) {
      const companyConfiguration = JSON.parse(
        this.localStorageService.get(STORAGE_KEY_COMPANY) || '{}',
      );
      return of(companyConfiguration);
    }
    log('Loading company configuration from API...');
    return this.userStore.currentTenant$.pipe(
      filter(Boolean),
      distinctUntilChanged(),
      switchMap((tenant) => {
        if (!tenant) {
          return EMPTY;
        }
        const tenantName = tenant.tenantName;
        return forkJoin(
          this.configurationApiClient.application_GetCompanyStructure(),
          this.configurationApiClient.role_Get(),
          this.loadTenantModules(tenant.companyId!),
        ).pipe(
          map(([structure, roles, modules]) => {
            log('Company structure:', structure);
            log('Company roles:', roles);
            log('Company modules:', modules);
            const units = structure.units || [];
            const avilableModules: ModuleEnhanced[] = (modules || []).map((module) => ({
              ...module,
              isRequired: module.name! === 'basic',
              readableName: ModulesLookup.modules[module.name!] || module.name!,
            }));

            const companyConfiguration: CompanyConfiguration = {
              avilableModules: avilableModules,
              avilableRoles: roles || [],
              avilableUnits: units,
              structure: structure,
            };
            this.localStorageService.set(STORAGE_KEY_COMPANY, JSON.stringify(companyConfiguration));
            return companyConfiguration;
          }),
        );
      }),
    );
  }
  loadTenantModules(companyId: number): Observable<ModuleDto[]> {
    if (!companyId) {
      return of([]);
    }
    return this.interalApiClient.company_GetActiveModules(companyId);
  }
}
